export const FAQ: { title: string; list: { title: string; description: string }[] }[] = [
    {
        title: 'GENERAL',
        list: [
            {
                title: 'What does Helicap Securities do?',
                description: `<p>Helicap Securities is a leading go-to-platform for curated alternative investments in Southeast Asia . It specialises in raising growth capital for early stage and mid-market enterprises in Asia from an exclusive network of institutional investors, family offices and High-Net-Worth Individuals.</p> <p className="pt-2"> Led by a team of highly experienced financing professionals, we provide debt and equity capital solutions to support our clients’ growth through a streamlined transaction process.</p> <p className="pt-2">We combine traditional investment banking best practices with innovations in financial technology to create a transparent and efficient platform for highly curated opportunities.</p>`,
            },
            {
                title: 'What type of companies does Helicap Securities assist to raise capital?',
                description: `<p>Our clients primarily consist of private companies, including but not limited to early stage technology-related companies with high-growth potential, and middle market enterprises seeking growth capital.</p> <p className="pt-2"> 1. Early stage growth companies – these companies will typically be technology companies that are looking to expand rapidly and require third party financing to fund their growth plans. They are likely to be too early-stage for traditional bank debt financing with limited near term cash flows and require a structured debt or private equity financing solution. They might be operating digitally and generate consistent and recurring revenue. We can assist these companies with raising early stage debt or equity financing from family offices, strategic investors, high net worth investors and venture capital investors.</p> <p className="pt-2">2. Established SMEs ("mid-market") – target clients will be companies which are unable to access further traditional financing such as senior bank debt and require funding to finance growth, working capital or refinancing. We can assist these companies to raise financing through debt, mezzanine or private equity structures.</p>`,
            },
            {
                title: 'What type of investors can register?',
                description: `<p>Our investors fall into several key categories: </p> <p className="pt-2">1. Institutions – these include private equity and venture capital funds, hedge funds, specialist credit funds and bank proprietary investing desks. These investors will typically be the target for mid-market opportunities with the exception of venture capital funds which will be the target for early stage opportunities.</p> <p className="pt-2">2. Family and Multi-Family Offices – these investors manage money and make investments on behalf of ultra-high net worth individuals. Investment criteria varies from investor to investor and these investors may be able to participate in mid-market and/or early stage opportunities. </p> <p className="pt-2">3. Accredited high-net-worth individuals – these investors typically look for early stage opportunities although sector and size requirements can vary.</p>`,
            },
            {
                title: 'I can’t find an answer to my question. How do I contact the team?',
                description: `Please contact our support team at <a href="mailto:deal@heli-cap.com">deal@heli-cap.com</a> or use our contact form.`,
            },
        ],
    },
    {
        title: 'FUND RAISING',
        list: [
            {
                title: 'What are the criteria for listing deals?',
                description: `We conduct a review of the business and investment opportunity to determine suitability for the Helicap Securities platform based on a number of factors including, but not limited to, the type of business, stage of growth, financing requirements and use of proceeds, proposed financing terms and structure.`,
            },
            {
                title: 'What are the fees?',
                description: `Our fees are competitive and success-based to align our incentives with those of the capital seekers and determined based on the type of financing being raised. Please contact our support team at <a href="mailto:deal@heli-cap.com" className="underline">deal@heli-cap.com</a> for more details.`,
            },
            {
                title: 'How long does a fund-raising process take?',
                description: `Transaction process typically takes 6-8 weeks including 2-3 weeks for diligence and preparation of materials, 2-3 weeks for marketing and 2-3 weeks for documentation and closing. This will be subject to Due diligence process and complexity of the deal structure.`,
            },
            {
                title: 'What documents are required for a capital raising?',
                description: `Marketing materials will typically consist of a company presentation or information memorandum and financing terms. Financial information will typically consist in monthly management accounts of the past 3 years along with latest audited reports when available. Transaction documentation prepared by counsel once terms have been agreed include a subscription agreement and may include other documents including security documents, intercreditor agreements depending on the type of transaction. Investors may also require other legal and business documentation to be provided for diligence purposes.`,
            },
            {
                title: 'Who is responsible for legal documentation?',
                description: `Companies are responsible for engaging their own legal counsel to assist with the preparation of all relevant legal documents (such as subscription/purchase agreement, etc.). This will typically occur once investors have agreed to financing terms. We are happy to recommend legal counsel if required.`,
            },
            {
                title: 'Are funds raised from investors transacted via Helicap Securities?',
                description:
                    'Once investor(s) have committed to the financing, funds will either be transferred directly to the company (the capital seeker) or our regulated and appointed escrow agent will facilitate the transfer of funds. For licensing purposes, Helicap Securities does not hold investor funds.',
            },
        ],
    },
    {
        title: 'INVESTING',
        list: [
            {
                title: 'What are the historical rates of return and non-performing loan rates?',
                description: `<p>
            <b>Rates of return and non-performing loan rates - 2022</b>
          </p>
          <div style={{ overflowX: 'auto' }}>
            <table className="tableBorder">
              <tr>
                <th rowSpan="2">Year of disbursement</th>
                <th colSpan="2"> Rates of return</th>
                <th colSpan="2">Non-performing loan rates</th>
              </tr>
              <tr>
                <td>Lowest and highest rates (per annum)</td>
                <td>Weighted average (per annum)</td>
                <td>Loans which are past 30 days but less than 90 days</td>
                <td>Loans which are past 90 days</td>
              </tr>
              <tr>
                <td>2022</td>
                <td>5.26% to 11.69%</td>
                <td>9.12%</td>
                <td>0%</td>
                <td>0%</td>
              </tr>
            </table>
            <p>(1) Historical returns may not reflect future returns.</p>
            <p>
              (2) There were 12 loans disbursed in 2022. The weighted average return is calculated based on the
              total amounts of loan disbursed in the different currencies.
            </p>
          </div>
          <p>Rates are shown net of fees and charges.</p>

          <p>
            <b>Rates of return and non-performing loan rates - 2021</b>
          </p>
          <div style={{ overflowX: 'auto' }}>
            <table className="tableBorder">
              <tr>
                <th rowSpan="2">Year of disbursement</th>
                <th colSpan="2"> Rates of return</th>
                <th colSpan="2">Non-performing loan rates</th>
              </tr>
              <tr>
                <td>Lowest and highest rates (per annum)</td>
                <td>Weighted average (per annum)</td>
                <td>Loans which are past 30 days but less than 90 days</td>
                <td>Loans which are past 90 days</td>
              </tr>
              <tr>
                <td>2021</td>
                <td>5.59% to 12.22%</td>
                <td>9.28%</td>
                <td>0%</td>
                <td>0%</td>
              </tr>
            </table>
            <p>(1) Historical returns may not reflect future returns.</p>
            <p>
              (2) There were 11 loans disbursed in 2021. The weighted average return is calculated based on the
              total amounts of loan disbursed in the different currencies.
            </p>
          </div>
          <p>Rates are shown net of fees and charges.</p>

          <p>
            <b>Rates of return and non-performing loan rates - 2020</b>
          </p>
          <div style={{ overflowX: 'auto' }}>
            <table className="tableBorder">
              <tr>
                <th rowSpan="2">Year of disbursement</th>
                <th colSpan="2"> Rates of return</th>
                <th colSpan="2">Non-performing loan rates</th>
              </tr>
              <tr>
                <td>Lowest and highest rates (per annum)</td>
                <td>Weighted average (per annum)</td>
                <td>Loans which are past 30 days but less than 90 days</td>
                <td>Loans which are past 90 days</td>
              </tr>
              <tr>
                <td>2020</td>
                <td>8.12% to 12.35%</td>
                <td>9.52%</td>
                <td>0%</td>
                <td>0%</td>
              </tr>
            </table>
            <p>(1) Historical returns may not reflect future returns.</p>
            <p>
              (2) There were 4 loans disbursed in 2020, and 8.12% and 12.35% represent the lowest and highest
              rates of return respectively. The weighted average return is calculated based on the total amounts
              of loan disbursed in the different currencies.
            </p>
          </div>
          <p>Rates are shown net of fees and charges.</p>
          <p>
            <b>Rates of return and non-performing loan rates - 2019</b>
          </p>
          <div style={{ overflowX: 'auto' }}>
            <table className="tableBorder">
              <tr>
                <th rowSpan="2">Year of disbursement</th>
                <th colSpan="2"> Rates of return</th>
                <th colSpan="2">Non-performing loan rates</th>
              </tr>
              <tr>
                <td>Lowest and highest rates (per annum)</td>
                <td>Weighted average (per annum)</td>
                <td>Loans which are past 30 days but less than 90 days</td>
                <td>Loans which are past 90 days</td>
              </tr>
              <tr>
                <td>2019</td>
                <td>8.53% to 9.53%</td>
                <td>9.15%</td>
                <td>0%</td>
                <td>0%</td>
              </tr>
            </table>
            <p>(1) Historical returns may not reflect future returns.</p>
            <p>
              (2) There was 1 loan disbursed in 2019. The loan had 2 different rates of return for different
              currencies - USD (9.53%) and SGD (8.53%). The weighted average return is calculated based on the
              total amounts of loan disbursed in both currencies.
            </p>
          </div>
          <p>Rates are shown net of fees and charges.</p>`,
            },
            {
                title: 'How do I start viewing opportunities?',
                description: 'You first need to register and confirm your accreditation status to view opportunities.',
            },
            {
                title: 'What type of instruments are available on the Helicap Securities platform ?',
                description: `We are able to raise capital across the capital structure from senior secured debt to more junior capital structure for investors who target higher returns.
                <p className="pt-2">Early Stage companies will typically raise funds via preferred equity or convertible debt structures. Preferred equity ranks senior only to common equity and may have priority over common stock upon liquidation or in respect to dividends. Convertible debt may be a loan or note which converts to common/preferred equity upon certain milestones being achieved at a valuation to be determined by a future fund raising or liquidity event.</p>                
                <p className="pt-2">SME structures may also employ non-traditional financing tools including mezzanine and private debt or equity structures that provide companies with funding flexibility while providing investors an enhanced return on capital or an opportunity to participate in future upside.</p>`,
            },
            {
                title: 'How long does a fund-raising process take?',
                description: `Transaction process typically takes 6-8 weeks including 2-3 weeks for diligence and preparation of materials, 2-3 weeks for marketing and 2-3 weeks for documentation and closing. This will be subject to Due diligence process and complexity of the deal structure.`,
            },
            {
                title: 'Can I invest below the minimum investment size of the deals?',
                description: `You may propose a size below the minimum but acceptance will be subject to the capital seeker's discretion and priority will typically be given to investors who have commitments above the minimum investment size. Please email us at deal@heli-cap.com for any queries with that regards.`,
            },
            {
                title: 'Who will handle fund transfers?',
                description: `Instructions will be given for investors to transfer funds directly to the capital seeker's bank account or in certain circumstances to our regulated and appointed escrow agent who will hold investor funds independently of Helicap Securities until closing when funds are transferred to the capital seeker's account.`,
            },
            {
                title: `Can I withdraw my commitment?`,
                description: `Once the subscription agreement has been signed, a commitment cannot be withdrawn.`,
            },
            {
                title: 'Does Helicap Securities charge investors fees?',
                description: `Helicap Securities may charge an access and facilitation fee on a case by case basis depending on the type of transaction.`,
            },
            {
                title: 'How are allocations determined?',
                description: `Allocations will be on a pro-rata basis where possible. Final allocations remain at the discretion of Helicap Securities and the Issuer.`,
            },
            {
                title: `Can you describe Helicap Securities' transaction process?`,
                description: `The transaction process consists of three stages:
                <p className="pt-2"><b>Stage 1:</b></p>
                <p className="pt-2">1. Registered investors are able to view summary information of opportunities listed on the platform.</p>
                <p className="pt-2">2. Any registered investor who is interested in receiving more detailed information may request to proceed to Stage 2 by showing interest in the deal.</p>
                
                <p className="pt-2"><b>Stage 2:</b></p>
                <p className="pt-2">1. Investors who request additional information will be reviewed by Helicap Securities and the Issuer and investors who are accepted will be granted access to additional information to evaluate the opportunity, for instance a full access to the target company’s data room.</p>
                <p className="pt-2">2. Investors can submit an initial non-binding indication of interest to be considered for Stage 3.</p>
                
                <p className="pt-2"><b>Stage 3:</b></p>
                <p className="pt-2">1. Shortlisted investors will be granted access to a detailed due diligence information and after review of the information will be expected to submit a binding commitment.</p>
                <p className="pt-2">2. Helicap Securities aims to provide investors with transparency and access to all transactions on our platform but we reserve the right to determine which transactions investors are able to view and we retain full discretion to determine which investors are shortlisted at each stage of the process.</p>`,
            },
        ],
    },
];
